// extracted by mini-css-extract-plugin
module.exports = {"baseStyledButton":"mMNOAxS7"};